import { Component } from '@angular/core';

import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-search-icon',
  template: `<svg
    [attr.width]="width"
    [attr.height]="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.33332 1.66666C4.65142 1.66666 1.66666 4.65142 1.66666 8.33332C1.66666 12.0152 4.65142 15 8.33332 15C9.87392 15 11.2925 14.4774 12.4214 13.5999L16.9107 18.0892C17.2362 18.4147 17.7638 18.4147 18.0892 18.0892C18.4147 17.7638 18.4147 17.2362 18.0892 16.9107L13.5999 12.4214C14.4774 11.2925 15 9.87392 15 8.33332C15 4.65142 12.0152 1.66666 8.33332 1.66666ZM3.33332 8.33332C3.33332 5.5719 5.5719 3.33332 8.33332 3.33332C11.0947 3.33332 13.3333 5.5719 13.3333 8.33332C13.3333 11.0947 11.0947 13.3333 8.33332 13.3333C5.5719 13.3333 3.33332 11.0947 3.33332 8.33332Z"
      [attr.fill]="color"
    />
  </svg> `,
})
export class SearchIcon extends BaseIconComponent {}
